import { ICON_SELECTOR, swapIcon } from '../helpers/w4d-icon.js';

(function ($) {
	class W4D_Helper {
		BREAKPOINTS = {
			xxl: 1660,
			xl: 1400,
			lg: 1200,
			md: 992,
			sm: 768,
			xs: 576,
			xxs: 480,
		};

		constructor() {
			this.initSelectors();
			this.bindEvents();
			this.initCapsLockIndicator();
		}

		initSelectors() {
			this.productCard = '.product-card';

			this.spinner = $('spinner');

			this.$blurScreen = $('.blur-screen');

			// Filters and Sort
			this.blurScreenTriggers = $('[data-js-blur-screen-trigger]');

			this.formInputAddOn = $('.form__input-add-on');

			this.capsIndicatorSelector = '.field__caps-indicator';
			this.passwordInputsSelector = 'input[type="password"]';
			this.passwordToggleSelector = '.password-toggle';
		}

		bindEvents() {
			$(document).on('click', this.productCard, (e) => this.handleProductCardClick(e));

			$(document).on('click', (e) => this.handleDocumentClick(e));
			this.blurScreenTriggers.on('click', () => this.toggleBlurFromScreen());

			this.formInputAddOn.on('click', (e) => this.handleFormInputAddOnClick(e));

			$(document).on('click', this.passwordToggleSelector, (e) => this.handlePasswordToggle(e));
		}

		initCapsLockIndicator() {
			if (typeof $(window).capslockstate !== 'function') {
				console.log('Plugin not loaded: capslockstate');
				return; // plugin not loaded
			}
			// Start monitoring at window level
			$(window).capslockstate();

			// Window-level caps events
			$('body')
				.on('capsOn', () => {
					const $focused = $(this.passwordInputsSelector + ':focus');
					if ($focused.length) this.toggleCapsIndicator($focused, true);
				})
				.on('capsOff capsUnknown', () => {
					const $focused = $(this.passwordInputsSelector + ':focus');
					if ($focused.length) this.toggleCapsIndicator($focused, false);
				});

			// Per-input focus lifecycle
			$(document)
				.on('focusin', this.passwordInputsSelector, (e) => {
					const $input = $(e.currentTarget);
					const state = $(window).capslockstate('state') === true;
					this.toggleCapsIndicator($input, state);
				})
				.on('focusout', this.passwordInputsSelector, (e) => {
					this.toggleCapsIndicator($(e.currentTarget), false);
				});
		}

		// Toggle .caps-lock-indicator--active on the indicator inside the input's parent
		toggleCapsIndicator($input, isActive) {
			const $indicator = $input.parent().find(this.capsIndicatorSelector).first();
			if ($indicator.length) {
				$indicator.toggleClass('field__caps-indicator--active', !!isActive);
			}
		}

		isBlurActive() {
			return this.$blurScreen.hasClass('blur-active');
		}

		handleDocumentClick(e) {
			if (!this.isBlurActive() || !this.$blurScreen.length) return;
			if (e.target === this.$blurScreen[0]) {
				this.$blurScreen.removeClass('blur-active');
				$('.product-list').removeClass('product-list--open');
			}
		}

		getBlurScreenThreshold() {
			const $screen = $('.blur-screen');
			if (!$screen.length) return null; // nema elementa => tretiraj kao “odmah toggle”
			const bp = $screen.attr('data-blur-screen-bp') || $screen.attr('data-blur-screen-mq') || '';
			if (!bp) return null;
			const key = String(bp).toLowerCase();
			return this.BREAKPOINTS[key] || this.BREAKPOINTS.lg; // fallback na lg
		}

		toggleBlurFromScreen() {
			const $el = $('.blur-screen');
			const threshold = this.getBlurScreenThreshold();

			// Nema breakpoint atributa => odmah toggle
			if (threshold === null) {
				$el.toggleClass('blur-active');
				return;
			}

			// Ima breakpoint => togglaj samo ispod praga
			if (window.innerWidth < threshold) {
				$el.toggleClass('blur-active');
			}
		}

		handleProductCardClick(e) {
			const selection = window.getSelection().toString();
			if (selection.length > 0) return;

			if (
				e.target.closest('button') ||
				e.target.closest('a') ||
				e.target.closest('.product-quantity') ||
				e.target.closest('.product-custom-quantity') ||
				e.target.closest('.product-card-carousel__nav') ||
				e.target.closest('.product-card-carousel__dots') ||
				e.target.closest('.swiper-pagination-bullet')
			) {
				return;
			}

			const link = e.currentTarget.querySelector('.product-card__link');
			if (link && link.href) {
				let href = link.href;

				// Handle gallery image index
				const $slide = $(e.target).closest('.product-card-carousel__slide');
				if ($slide.length) {
					const $carousel = $slide.closest('.product-card-carousel');
					const index = $carousel.find('.product-card-carousel__slide').index($slide);
					if (index !== -1) {
						try {
							const url = new URL(href, window.location.origin);
							if (index > 0) {
								url.searchParams.set('imgIndex', index);
							} else {
								url.searchParams.delete('imgIndex');
							}
							href = url.toString();
						} catch (err) {}
					}
				}

				window.location.href = href;
			}
		}

		handleFormInputAddOnClick(e) {
			$(e.currentTarget).closest('.form__input-wrapper').find('input').focus();
		}

		handlePasswordToggle(e) {
			const $btn = $(e.currentTarget);
			const $input = $btn.closest('.field__input-wrapper').find('input');
			const isPassword = $input.attr('type') === 'password';

			// Toggle input type
			$input.attr('type', isPassword ? 'text' : 'password');

			// Toggle aria-label
			$btn.attr('aria-label', isPassword ? 'Sakrij lozinku' : 'Prikaži lozinku');

			// Toggle icon (eye / eye-closed)
			swapIcon($btn.find(ICON_SELECTOR), isPassword ? 'eye' : 'eye-closed');
		}
	}

	$(document).ready(function () {
		window.W4D_Helper = new W4D_Helper();
		// 1) GLOBAL STORE (simple, debuggable)
		window.W4D_FileStore = {
			get(el) {
				const id = typeof el === 'string' ? el : el.id;
				return $(`#${id}`).data('w4dFiles') || [];
			},
			set(el, arr) {
				const id = typeof el === 'string' ? el : el.id;
				$(`#${id}`).data('w4dFiles', arr);
			},
			add(el, list) {
				const arr = this.get(el).slice();
				for (const f of list) arr.push(f);
				this.set(el, arr);
			},
			removeAt(el, i) {
				const arr = this.get(el).slice();
				arr.splice(i, 1);
				this.set(el, arr);
			},
			clear(el) {
				this.set(el, []);
			},
		};
	});
})(jQuery);
